var scope_0 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/44f711242964f8cf7f1a7de6b677a0ca.js').default;
var scope_1 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48e041a73f343ab48b3be3a8a19a9af4.js').default;
var scope_2 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6713973961a369c80ecc356be03fb600.js').default;
var scope_3 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ba0738d8943b6cce89c9eeff0f348d9.js').default;
var scope_4 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f8fab87963562edfbfe84d2e90fbdf3.js').default;
var scope_5 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8d1280e9fa4fc43f7172c4782b8ee79f.js').default;
var scope_6 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_7 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ab2e2c4de9d2e683caa48ca52b22f7cb.js').default;
var scope_8 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b20a5fd78361bf314ed17bc0af87d89c.js').default;
var scope_9 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b32d4f7588f5cb9b5575fd74600a1fec.js').default;
var scope_10 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cb7b6786cde477231e844867fdb30ec4.js').default;
var scope_11 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e10495c65c8acacd6b1f785f5759a9c8.js').default;
var scope_12 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/opt/build/repo/monodocs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    